<template lang="pug">
  .work-area(v-bar)
    .thread(@scroll="test" ref="top")
      post.main-container(v-for="(post, index) in items" :post="post" :key="post.id"
      :itemIndex="index")
      table-preloader(v-if="reqPending" style="margin-top: 4em")
      scroll-top-button(@onScroll="handleScroll" v-if="position")
</template>

<script>
import Post from '@/components/posts/post.vue';
import { getPostsApi } from '@/api/posts';
import TablePreloader from '@/components/preLoaders/tablePreloader.vue';
import ScrollTopButton from '@/components/ScrollTopButton.vue';

export default {
  name: 'Home',
  components: { TablePreloader, Post, ScrollTopButton },
  data() {
    return {
      items: [],
      reqPending: false,
      count: '',
      start: 0,
      limit: 20,
      position: 0,
    };
  },
  methods: {
    handleScroll() {
      this.$refs.top.scrollTop = 0;
    },
    updateContentScrollPosition(element) {
      this.position = element.scrollTop;
    },
    test($event) {
      const element = $event.target;
      this.updateContentScrollPosition(element);

      if (!this.reqPending) {
        const element = $event.target;
        if (element.scrollHeight - element.scrollTop >= element.clientHeight - 100) {
          if (this.items.length + 1 < this.count) {
            this.getPosts(process.env.VUE_APP_THREAD_ID);
          }
        }
      }
    },
    getPosts(id) {
      this.reqPending = true;
      const params = {
        thread_id: id,
        limit: this.limit,
        start: this.start,
        sort: {
          type: 'date',
          order: 'desc',
        },
        // from: this.$moment().subtract(14, 'days').format('YYYY-MM-DD HH:mm:ss'),
        // to: this.$moment().format('YYYY-MM-DD HH:mm:ss'),
      };
      getPostsApi(params)
        .then((req) => {
          req.data.posts.forEach((elem) => {
            this.items.push(elem);
          });
          this.reqPending = false;
          this.count = req.data.count;
          this.start += this.limit;
        })
        .catch((err) => {
          this.reqPending = false;
          return err;
        });
    },
    getHeight() {
        const headerHeight = window.document.querySelector('.header').offsetHeight;
        document.querySelector('.wrapper').style.height = `${document.body.offsetHeight - headerHeight - document.querySelector('.work-area').style.marginTop - document.querySelector('.work-area').style.marginBottom}px`;
    },
  },
  mounted() {
    this.items = [];
    this.count = '';
    this.getHeight();
    this.getPosts(process.env.VUE_APP_THREAD_ID);
    setInterval(() => {
      this.reqPending = true;
      const params = {
        thread_id: process.env.VUE_APP_THREAD_ID,
        limit: 0,
        start: 20,
        sort: {
          type: 'date',
          order: 'desc',
        },
      };
      getPostsApi(params)
        .then((req) => {
          let startPostState = false;
          let startPostId = this.items[0].id;
          let arr = [];
          req.data.posts.forEach((elem) => {
            if (this.items.length) {
              if (!startPostState) {
                if (elem.id === startPostId) {
                  startPostState = true
                } else {
                  arr.push(elem);
                  this.start = this.start + 1;
                }
              }
            }
          });
          if (arr.length) {
            this.items = arr.concat(this.items);
          }
          this.reqPending = false;
        })
    }, 40000);
  },
  watch: {
    $route() {
      this.items = [];
      this.getPosts(process.env.VUE_APP_THREAD_ID);
    },
  },
};
</script>
